<template>
  <div class="interview-management-container">
    <div class="search">
      <el-input
        v-model="search.keywords"
        clearable
        class="keywords-searcher"
        prefix-icon="el-icon-search"
        :placeholder="$t(`${i18nPrefix}.placeholder.keywordSearch`)"
      >
      </el-input>
      <el-select
        v-model="search.status"
        multiple
        clearable
        class="status-selector"
        :placeholder="$t(`${i18nPrefix}.placeholder.allStatus`)"
      >
        <el-option
          v-for="(value, key) in INTERVIEW_STATUS"
          :key="key"
          :value="value"
          :label="$t(`${i18nPrefix}.label.${key}`)"
        >
        </el-option>
      </el-select>
    </div>
    <InterviewTable
      class="interview-table"
      :data="listData"
      :loading="loading"
      :tableColumnWidthMap="tableColumnWidthMap"
      :isProfile="true"
      :isDisabled="isDisabled"
      :defaultExpandAll="defaultExpandAll"
      @search="handleSearch"
      @edit="handleEdit"
      @cancel="handleCancel"
      @resend="handleResend"
      @sendNew="handleSendNew"
      @sendRating="handleSendRating"
      @confirmInterview="handleConfirmInterview"
      @viewGroupInterview="handleViewGroupInterview"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { INTERVIEW_STATUS } from '@/constant/interview'
import InterviewTable from '@/components/interview/interviewTable.vue'

export default {
  components: {
    InterviewTable
  },
  props: {
    listData: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    }
  },
  metaInfo () {
    return {
      style: [
        {
          innerHTML: `.el-tooltip__popper.is-light {
            border-color: #e6e6e6;
            background: #e6e6e6;
            -webkit-box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
                    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
          }
          .el-tooltip__popper.is-light[x-placement] .popper__arrow {
            border-bottom-color: #e6e6e6;
            border-top-color: #e6e6e6;
          }
          .el-tooltip__popper.is-light[x-placement] .popper__arrow::after {
            border-bottom-color: #e6e6e6;
            border-top-color: #e6e6e6;
          }`
        }
      ]
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      INTERVIEW_STATUS,
      emitSearch: null,
      search: {
        keywords: null,
        status: null
      },
      tableColumnWidthMap: {
        interviewDate: 270,
        recruiter: 150,
        hiringManagerNames: 150,
        candidateNames: 248,
        status: 160,
        interviewResult: 130,
        action: 130
      }
    }
  },
  computed: {
    hasInterviewPermission () {
      return this.hasAnyPermission(['PREMIUM_INTERVIEW_SCHEDULING', 'PERM_HR_INTERVIEW_SCHEDULING'])
    }
  },
  created () {
    this.emitSearch = _.debounce(() => {
      this.$emit('search', this.search)
    }, 500)
  },
  methods: {
    handleCommand (record, command) {
      if (command === 'sendInterviewRating') {
        this.handleSendRating(record)
      }
    },
    handleEdit (record) {
      this.$emit('edit', record)
    },
    handleCancel (record) {
      this.$emit('cancel', record)
    },
    handleResend (record) {
      this.$emit('resend', record)
    },
    handleSendNew (record) {
      this.$emit('sendNew', record)
    },
    handleSendRating (record) {
      this.$emit('sendRating', record)
    },
    handleConfirmInterview (record) {
      this.$emit('confirmInterview', record)
    },
    handleViewGroupInterview (record) {
      this.$emit('viewGroupInterview', record)
    },
    handleSearch (keywords) {
      this.$emit('search', keywords)
    }
  },
  watch: {
    search: {
      deep: true,
      handler () {
        this.emitSearch()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.interview-management-container {
  .search {
    margin-top: 20px;
    display: flex;

    .keywords-searcher {
      width: 315px;
    }

    .status-selector {
      margin-left: 25px;
      width: 490px;
    }

    ::v-deep .el-input__inner {
      border-radius: 0;

      &:focus {
        border-color: #b2b2b2;
      }

      &:hover {
        border-color: #C0C4CC;
      }
    }
  }

  .interview-table {
    margin-top: 30px;
    border: 1px solid #EBEEF5;
  }
}
</style>
